import { createSlice } from '@reduxjs/toolkit';

const initialState: { allProvincesWithoutSearch?: any[] } = { allProvincesWithoutSearch: undefined };

export const provinceSlice = createSlice({
  name: 'province',
  initialState,
  reducers: {
    setAllProvincesWithoutSearch: (state, { payload }) => {
      state.allProvincesWithoutSearch = payload;
    },
  },
});

export const { setAllProvincesWithoutSearch } = provinceSlice.actions;

export default provinceSlice.reducer;
